import { FC, useState } from "react";

import { formatMediasDateTime } from "../../../../utils/formatDate";
import ArrowIcon from "../../../../assets/icons/chevron.svg";

import { IReportMediaOptions } from "../../../../types/reportsInterfaces";

interface ICustomerPhotoOptions {
  setSelectedPhoto: (state: string) => void;
  medias: IReportMediaOptions[];
  title: string;
}

const CustomerPhotoTableSection: FC<ICustomerPhotoOptions> = ({
  setSelectedPhoto,
  medias,
  title,
}) => {
  const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

  return (
		<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
      <span className="section__title">{title}</span>
      <button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
			</button>
      <div className="customer__photo_table">
        {medias.map((elem: IReportMediaOptions, index: number) => (
          <div className="customer__photo_block" key={index}>
            <div className="photo__block_row">
              <img
                src={elem?.url?.link}
                onClick={() => setSelectedPhoto(elem?.url?.link)}
                className="photo__img"
                id={String(elem.media.id)}
                alt="product"
              />
            </div>
            <div className="photo__block_row">
              <span className="photo__card_name">{elem.media.name}</span>
            </div>
            <div className="photo__block_row">
              <span>{elem.date && formatMediasDateTime(elem.date)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerPhotoTableSection;
